import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-brand-light py-16 sm:py-20" data-id="element-90" data-mp="1ckwmoevoutp3">
      <div className="mx-auto max-w-6xl" data-id="element-91" data-mp="1clfwt9f3kdsk">
        <div className="px-5" data-id="element-92" data-mp="18k4c9ib2yir8">
          <p className="mx-auto flex w-fit items-center gap-2 rounded-full bg-accent px-4 py-1.5 text-sm font-extrabold text-white" data-id="element-93" data-mp="18kvvdtnhqo0m">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-94" data-mp="257hdne8953s4" /> Plus 5 Practical Bonuses
          </p>
          <h2 className="mt-4 text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-95" data-mp="208xqxblu3nyp">
            Additional Tools to Make Your Planning Workflow Easier to Apply
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-navy/75" data-id="element-96" data-mp="ku0bdipa0x3x">
            These complementary resources support specific tasks without replacing the six core volumes.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 sm:px-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-97" data-mp="1et56so91jr3s">
          {bonuses.map((b, i) => <article key={b.title} className="flex flex-col overflow-hidden bg-white shadow-sm sm:rounded-3xl" data-id="element-98" data-mp="1jrghf175u5n2" data-mpi={i}>
              <div className="relative" data-id="element-99" data-mp="15sgpnkocpamo">
                <img src={b.image} alt={`Bonus 0${i + 1}: ${b.title}`} className="block aspect-[4/3] w-full object-cover" data-id="element-100" data-mp="1as1u2amaib6s" />
                <span className="absolute left-4 top-4 rounded-full bg-accent px-3 py-1 text-sm font-extrabold text-white" data-id="element-101" data-mp="w2x6sf0n1grt">Bonus 0{i + 1}</span>
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-102" data-mp="10vq9yyggkh1s">
                <h3 className="font-display text-xl font-extrabold leading-snug text-navy" data-id="element-103" data-mp="n3s7v7l5zlf4">{b.title}</h3>
                <p className="mt-2 text-[15px] text-navy/75" data-id="element-104" data-mp="r4lxc5e998a4">{b.description}</p>
                <p className="mt-4 text-xs font-bold uppercase tracking-wider text-brand" data-id="element-105" data-mp="d5cjvdhfos9u">Includes:</p>
                <ul className="mt-2 space-y-2" data-id="element-106" data-mp="i2crvtxug53l">
                  {b.items.map(it => <li key={it} className="flex gap-2 text-[15px] text-navy/85" data-id="element-107" data-mp="2jtlk3ofuc0i2">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-108" data-mp="2f1bl7iwqzq3n" />
                      {it}
                    </li>)}
                </ul>
                <p className="mt-auto pt-5 text-sm text-navy" data-id="element-109" data-mp="261f17ulazfex">
                  <span className="mt-0 block rounded-xl bg-brand-light p-3" data-id="element-110" data-mp="25z2dt1ws0cuh"><strong data-id="element-111" data-mp="32qeczjl3izbv">Best used when:</strong> {b.bestUsed}</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="px-5" data-id="element-112" data-mp="2ynzrsstyfnhf">
          <SectionCTA label="Unlock the 5 Bonuses Too" data-id="element-113" data-mp="2tpyd0k3kaabr" />
        </div>
      </div>
    </section>;
}